import { render, staticRenderFns } from "./BaseCircleButton.vue?vue&type=template&id=2423ea8b"
import script from "./BaseCircleButton.vue?vue&type=script&lang=js"
export * from "./BaseCircleButton.vue?vue&type=script&lang=js"
import style0 from "./BaseCircleButton.vue?vue&type=style&index=0&id=2423ea8b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports